import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import currentRouteParamsRecordId from 'root/src/client/logic/route/selectors/currentRouteParamsRecordId'
import { DELIVERY_DARE } from 'root/src/shared/descriptions/endpoints/endpointIds'
import parse from 'qs/lib/parse'
import split from 'ramda/src/split'
import prop from 'ramda/src/prop'
import has from 'ramda/src/has'
import toLower from 'ramda/src/toLower'
import test from 'ramda/src/test'
import match from 'ramda/src/match'
import is from 'ramda/src/is'
import trim from 'ramda/src/trim'
import isNil from 'ramda/src/isNil'
import head from 'ramda/src/head'
import includes from 'ramda/src/includes'
import mixpanel from 'root/src/client/logic/analytics/mixpanel'
import { mixpanelEvents } from 'root/src/shared/constants/mixpanel'
import pipe from 'ramda/src/pipe'
import tail from 'ramda/src/tail'
import displayModal from 'root/src/client/logic/modal/actions/displayModal'
import { SUCCESS_MODAL_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import { CONNECTED_CHANNELS_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'
import pushRouteClient from 'root/src/client/logic/route/util/pushRouteClient'
import { platformsLabelMap } from 'root/src/shared/constants/providers'
import { events } from 'root/src/shared/constants/analytics'
import analyticsSendItem from 'root/src/client/logic/analytics/util/analyticsSendItem'
import userIdSelector from 'root/src/client/logic/auth/selectors/userIdSelector'

const getQueryString = (videoURL) => {
	const splitUrlPath = pipe(
		split(/[#?]/),
		tail,
	)(videoURL)
	if (!splitUrlPath.length) return undefined

	return includes('t=', prop(0, splitUrlPath))
		? prop(0, splitUrlPath)
		: prop(1, splitUrlPath)
}

// TODO refactor that so we'd have error message directly from server
const errorMessages = {
	NotFound: {
		videoURL: 'Please make sure your link works and try again in a couple minutes.',
	},
	VideoNotPublic: {
		videoURL: 'Video must be public',
	},
	DeliveryUrlNotSupported: {
		videoURL: 'This url is not supported, try with different one',
	},
	ScopeNotAuthorized: {
		videoURL: 'Please disconnect your TikTok channel, then reconnect it and try again.',
	},
	TikTokVideoNotFound: {
		videoURL: 'TikTok video not found on your account',
	},
	YouTubeClipNotSupported: {
		videoURL: 'YouTube clips aren\'t supported yet. Please use video link with correct timestamp',
	},
}

export default formData => async (dispatch, getState) => {
	const state = getState()
	const projectUrl = currentRouteParamsRecordId(state)
	const apiPayload = {
		...formData,
		projectUrl,
	}
	const queryString = getQueryString(apiPayload.videoURL)
	const parsedQuery = parse(queryString)
	let timeStamp = '00:00:00'
	if (has('t', parsedQuery) && is(String, prop('t', parsedQuery))) {
		const startTime = trim(toLower(prop('t', parsedQuery)))
		const timeUnitToNumber = (timeUnit, value) => {
			if (isNil(value)) return '00'
			return head(split(timeUnit, value))
		}
		if (test(/^([0-9]+h)?([0-9]+m)?([0-9]+s)?$/, startTime)) {
			const timeArray = match(/^([0-9]+h)?([0-9]+m)?([0-9]+s)?$/, startTime)
			timeStamp = `${timeUnitToNumber('h', timeArray[1])}:${timeUnitToNumber('m', timeArray[2])}:${timeUnitToNumber('s', timeArray[3])}`
		}
	}
	const response = await dispatch(apiRequest(DELIVERY_DARE, { ...apiPayload, timeStamp }))

	const { error } = response

	if (error) {
		if (error.code === 'PlatformAccountNotFound') {
			const platformName = platformsLabelMap[error.props.platform]

			dispatch(displayModal(SUCCESS_MODAL_MODULE_ID, {
				header: `${platformName} account not found`,
				errorText: error.message,
				infoText: '',
				buttonLabel: `Connect your ${platformName} account`,
				buttonOnClick: () => pushRouteClient({ routeId: CONNECTED_CHANNELS_ROUTE_ID }),
			}))

			throw error
		}
		const { code, message } = error
		throw errorMessages[code] || {
			videoURL: message ?? 'Something went wrong, please try again later',
		}
	}
	mixpanel.track(mixpanelEvents.dareDelivery)
	const userId = userIdSelector(state)
	analyticsSendItem(events.deliveredDare, userId)
	return response
}
